import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import { createAgreement } from 'src/shared/entities/agreement/create-agreement'
import { createAudio } from 'src/shared/entities/audio/create-audio'
import { createBlogCategoryDescription } from 'src/shared/entities/blog-category-description/create-blog-category-description'
import { createBlogCategoryTitle } from 'src/shared/entities/blog-category-title/create-blog-category-title'
import { createBlogContentPlaceholder } from 'src/shared/entities/blog-content-placeholder/create-blog-content-placeholder'
import { createBlogLatestPosts } from 'src/shared/entities/blog-latest-posts/create-blog-latest-posts'
import { createBlogPostCategories } from 'src/shared/entities/blog-post-categories/create-blog-post-categories'
import { createBlogPostContentTable } from 'src/shared/entities/blog-post-content-table/create-blog-post-content-table'
import { createBlogPostDate } from 'src/shared/entities/blog-post-date/create-blog-post-date'
import { createBlogPostImage } from 'src/shared/entities/blog-post-image/create-blog-post-image'
import { createBlogPostListing } from 'src/shared/entities/blog-post-listing/create-blog-post-listing'
import { createBlogPostTitle } from 'src/shared/entities/blog-post-title/create-blog-post-title'
import { createBookingCalendar } from 'src/shared/entities/booking-calendar/create-booking-calendar'
import { createBreadcrumbs } from 'src/shared/entities/breadcrumbs/create-breadcrumbs'
import { createBulletList } from 'src/shared/entities/bullet-list/create-bullet-list'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { createCarousel } from 'src/shared/entities/carousel/create-carousel'
import { createCheckbox } from 'src/shared/entities/checkbox/create-checkbox'
import { createColumn } from 'src/shared/entities/column/create-column'
import { createContactUs } from 'src/shared/entities/contact-us/create-contact-us'
import { createContactUsButton } from 'src/shared/entities/contact-us-button/create-contact-us-button'
import { createContentBox } from 'src/shared/entities/content-box/create-content-box'
import { createCountdown } from 'src/shared/entities/countdown/create-countdown'
import { createCoupon } from 'src/shared/entities/coupon/create-coupon'
import { createNewCustomLogin } from 'src/shared/entities/custom-login/create-custom-login'
import { createCustomerType } from 'src/shared/entities/customer-type/create-customer-type'
import { createFacebookComments } from 'src/shared/entities/facebook-comments/create-facebook-comments'
import { createFaq } from 'src/shared/entities/faq/create-faq'
import { createField } from 'src/shared/entities/field/create-field'
import { createHeadline } from 'src/shared/entities/headline/create-headline'
import { createHorizontalLine } from 'src/shared/entities/horizontal-line/create-horizontal-line'
import { createImage } from 'src/shared/entities/image/create-image'
import { createLatestBlogPostsCarousel } from 'src/shared/entities/latest-blog-posts-carousel/create-latest-blog-posts-carousel'
import { createMenu } from 'src/shared/entities/menu/create-menu'
import { createOfferPrice } from 'src/shared/entities/offer-price/create-offer-price'
import { createOrderBump } from 'src/shared/entities/order-bump/create-order-bump'
import { createOrderSummary } from 'src/shared/entities/order-summary/create-order-summary'
import { createPaymentButton } from 'src/shared/entities/payment-button/create-payment-button'
import { createPaymentMethod } from 'src/shared/entities/payment-method/create-payment-method'
import { createPopup } from 'src/shared/entities/popup/create-popup'
import { createProduct } from 'src/shared/entities/product/create-product'
import { createRawHtml } from 'src/shared/entities/raw-html/create-raw-html'
import { createRecaptcha } from 'src/shared/entities/recaptcha/create-recaptcha'
import { createRow } from 'src/shared/entities/row/create-row'
import { createSalesRedirectionButton } from 'src/shared/entities/sales-redirection-button/create-sales-redirection-button'
import { createSearchResults } from 'src/shared/entities/search-results/create-search-results'
import { createSection } from 'src/shared/entities/section/create-section'
import { createShippingFees } from 'src/shared/entities/shipping-fees/create-shipping-fees'
import { createSurvey } from 'src/shared/entities/survey/create-survey'
import { createText } from 'src/shared/entities/text/create-text'
import { createTwitterTweetButton } from 'src/shared/entities/twitter-tweet-button/create-twitter-tweet-button'
import { createTwoStepPaymentForm } from 'src/shared/entities/two-step-payment-form/create-two-step-payment-form'
import {
  createUpsellAgreeButton,
  createUpsellDisagreeButton,
} from 'src/shared/entities/upsell-button/create-upsell-button'
import { createVideo } from 'src/shared/entities/video/create-video'
import { createWebinarCallToAction } from 'src/shared/entities/webinar-call-to-action/create-webinar-call-to-action'
import { createWebinarRegistrationDate } from 'src/shared/entities/webinar-registration-date/create-webinar-registration-date'
import { createWebinarSessionDateTime } from 'src/shared/entities/webinar-session-date-time/create-webinar-session-date-time'
import { createWebinarSessionLink } from 'src/shared/entities/webinar-session-link/create-webinar-session-link'
import { createWebinarSessionVideo } from 'src/shared/entities/webinar-session-video/create-webinar-session-video'
import { TemporaryAny } from 'src/shared/types/temporary-any'
import { createForm } from './form/create-form'
import { createSearch } from './search/create-search'

// NOTE: This class is used for extending the common library elements creators in the specific library elements creators
// DON'T USE THIS CLASS DIRECTLY, use the specific library elements creators instead
// (e.g. WebsiteLibraryElementsCreator, PageLibraryElementsCreator)
export class CommonLibraryElementsCreator {
  public [LibraryElementEnum.LibraryButton](
    ...args: Parameters<typeof createButtonNew>
  ) {
    return createButtonNew(...args)
  }
  public [LibraryElementEnum.LibraryContactUsButton](
    ...args: Parameters<typeof createContactUsButton>
  ) {
    return createContactUsButton(...args)
  }
  public [LibraryElementEnum.LibraryField](
    ...args: Parameters<typeof createField>
  ) {
    return createField(...args)
  }
  public [LibraryElementEnum.LibraryMenu](
    ...args: Parameters<typeof createMenu>
  ) {
    return createMenu(...args)
  }
  public [LibraryElementEnum.LibraryHeadline](
    ...args: Parameters<typeof createHeadline>
  ) {
    return createHeadline(...args)
  }
  public [LibraryElementEnum.LibraryText](
    ...args: Parameters<typeof createText>
  ) {
    return createText(...args)
  }
  public [LibraryElementEnum.LibraryPopup](
    ...args: Parameters<typeof createPopup>
  ) {
    return createPopup(...args)
  }
  public [LibraryElementEnum.LibraryForm](
    ...args: Parameters<typeof createForm>
  ) {
    return createForm(...args)
  }
  public [LibraryElementEnum.LibraryCoupon](
    ...args: Parameters<typeof createCoupon>
  ) {
    return createCoupon(...args)
  }
  public [LibraryElementEnum.LibraryBulletList](
    ...args: Parameters<typeof createBulletList>
  ) {
    return createBulletList(...args)
  }
  public [LibraryElementEnum.LibraryCheckbox](
    ...args: Parameters<typeof createCheckbox>
  ) {
    return createCheckbox(...args)
  }
  public [LibraryElementEnum.LibraryFacebookComments](
    ...args: Parameters<typeof createFacebookComments>
  ) {
    return createFacebookComments(...args)
  }
  public [LibraryElementEnum.LibraryAudio](
    ...args: Parameters<typeof createAudio>
  ) {
    return createAudio(...args)
  }
  public [LibraryElementEnum.LibraryVideo](
    ...args: Parameters<typeof createVideo>
  ) {
    return createVideo(...args)
  }
  public [LibraryElementEnum.LibraryCalendar](
    ...args: Parameters<typeof createBookingCalendar>
  ) {
    return createBookingCalendar(...args)
  }
  public [LibraryElementEnum.LibraryPaidCalendar](
    ...args: Parameters<typeof createBookingCalendar>
  ) {
    return createBookingCalendar(...args)
  }
  public [LibraryElementEnum.LibraryCarousel](
    ...args: Parameters<typeof createCarousel>
  ) {
    return createCarousel(...args)
  }
  public [LibraryElementEnum.LibraryRawHTML](
    ...args: Parameters<typeof createRawHtml>
  ) {
    return createRawHtml(...args)
  }
  public [LibraryElementEnum.LibrarySection](
    ...args: Parameters<typeof createSection>
  ) {
    return createSection(...args)
  }
  public [LibraryElementEnum.LibraryColumn3](
    ...args: Parameters<typeof createColumn>
  ) {
    return createColumn(...args)
  }
  public [LibraryElementEnum.LibraryColumn4](
    ...args: Parameters<typeof createColumn>
  ) {
    return createColumn(...args)
  }
  public [LibraryElementEnum.LibraryColumn6](
    ...args: Parameters<typeof createColumn>
  ) {
    return createColumn(...args)
  }
  public [LibraryElementEnum.LibraryRow](
    ...args: Parameters<typeof createRow>
  ) {
    return createRow(...args)
  }
  public [LibraryElementEnum.LibraryContentBox](
    ...args: Parameters<typeof createContentBox>
  ) {
    return createContentBox(...args)
  }
  public [LibraryElementEnum.LibraryFaq](
    ...args: Parameters<typeof createFaq>
  ) {
    return createFaq(...args)
  }
  public [LibraryElementEnum.LibraryHorizontalLine](
    ...args: Parameters<typeof createHorizontalLine>
  ) {
    return createHorizontalLine(...args)
  }
  public [LibraryElementEnum.LibraryImage](
    ...args: Parameters<typeof createImage>
  ) {
    return createImage(...args)
  }
  public [LibraryElementEnum.LibraryTwitterTweetButton](
    ...args: Parameters<typeof createTwitterTweetButton>
  ) {
    return createTwitterTweetButton(...args)
  }
  public [LibraryElementEnum.LibrarySurvey](
    ...args: Parameters<typeof createSurvey>
  ) {
    return createSurvey({ ...args[0] })
  }
  public [LibraryElementEnum.LibraryCountdown](
    ...args: Parameters<typeof createCountdown>
  ) {
    return createCountdown(...args)
  }
  public [LibraryElementEnum.LibraryOfferPrice](
    ...args: Parameters<typeof createOfferPrice>
  ) {
    return createOfferPrice(...args)
  }
  public [LibraryElementEnum.LibraryCustomerType](
    ...args: Parameters<typeof createCustomerType>
  ) {
    return createCustomerType(...args)
  }
  public [LibraryElementEnum.LibraryPaymentMethod](
    ...args: Parameters<typeof createPaymentMethod>
  ) {
    return createPaymentMethod(...args)
  }
  public [LibraryElementEnum.LibraryOrderBump](
    ...args: Parameters<typeof createOrderBump>
  ) {
    return createOrderBump(...args)
  }
  public [LibraryElementEnum.LibraryOrderSummary](
    ...args: Parameters<typeof createOrderSummary>
  ) {
    return createOrderSummary(...args)
  }
  public [LibraryElementEnum.LibraryTwoStepPaymentForm](
    ...args: Parameters<typeof createTwoStepPaymentForm>
  ) {
    return createTwoStepPaymentForm(...args)
  }
  public [LibraryElementEnum.LibraryUpsellAgreeButton](
    ...args: Parameters<typeof createUpsellAgreeButton>
  ) {
    return createUpsellAgreeButton(...args)
  }
  public [LibraryElementEnum.LibraryUpsellDisagreeButton](
    ...args: Parameters<typeof createUpsellDisagreeButton>
  ) {
    return createUpsellDisagreeButton(...args)
  }
  public [LibraryElementEnum.LibrarySalesRedirectionButton](
    ...args: Parameters<typeof createSalesRedirectionButton>
  ) {
    return createSalesRedirectionButton(...args)
  }
  public [LibraryElementEnum.LibraryPaymentButton](
    ...args: Parameters<typeof createPaymentButton>
  ) {
    return createPaymentButton(...args)
  }
  public [LibraryElementEnum.LibraryAgreement](
    ...args: Parameters<typeof createAgreement>
  ) {
    return createAgreement(...args)
  }
  public [LibraryElementEnum.LibraryShippingFees](
    ...args: Parameters<typeof createShippingFees>
  ) {
    return createShippingFees(...args)
  }
  public [LibraryElementEnum.LibraryProduct](
    ...args: Parameters<typeof createProduct>
  ) {
    return createProduct(...args)
  }
  public [LibraryElementEnum.LibraryBlogPostListing](
    ...args: Parameters<typeof createBlogPostListing>
  ) {
    return createBlogPostListing(...args)
  }
  public [LibraryElementEnum.LibraryContentTable](
    ...args: Parameters<typeof createBlogPostContentTable>
  ) {
    return createBlogPostContentTable(...args)
  }
  public [LibraryElementEnum.LibrarySearchResults](
    ...args: Parameters<typeof createSearchResults>
  ) {
    return createSearchResults(...args)
  }
  public [LibraryElementEnum.LibrarySearch](
    ...args: Parameters<typeof createSearch>
  ) {
    return createSearch(...args)
  }
  public [LibraryElementEnum.LibraryBlogLatestPosts](
    ...args: Parameters<typeof createBlogLatestPosts>
  ) {
    return createBlogLatestPosts(...args)
  }
  public [LibraryElementEnum.LibraryBreadcrumbs](
    ...args: Parameters<typeof createBreadcrumbs>
  ) {
    return createBreadcrumbs(...args)
  }
  public [LibraryElementEnum.LibraryBlogPostDate](
    ...args: Parameters<typeof createBlogPostDate>
  ) {
    return createBlogPostDate(...args)
  }
  public [LibraryElementEnum.LibraryBlogPostCategories](
    ...args: Parameters<typeof createBlogPostCategories>
  ) {
    return createBlogPostCategories(...args)
  }
  public [LibraryElementEnum.LibraryBlogCategoryTitle](
    ...args: Parameters<typeof createBlogCategoryTitle>
  ) {
    return createBlogCategoryTitle(...args)
  }
  public [LibraryElementEnum.LibraryBlogCategoryDescription](
    ...args: Parameters<typeof createBlogCategoryDescription>
  ) {
    return createBlogCategoryDescription(...args)
  }
  public [LibraryElementEnum.LibraryBlogPostTitle](
    ...args: Parameters<typeof createBlogPostTitle>
  ) {
    return createBlogPostTitle(...args)
  }
  public [LibraryElementEnum.LibraryBlogContentPlaceholder](
    ...args: Parameters<typeof createBlogContentPlaceholder>
  ) {
    return createBlogContentPlaceholder(...args)
  }
  public [LibraryElementEnum.LibraryLatestBlogPostsCarousel](
    ...args: Parameters<typeof createLatestBlogPostsCarousel>
  ) {
    return createLatestBlogPostsCarousel(...args)
  }
  public [LibraryElementEnum.LibraryContactUs](
    ...args: Parameters<typeof createContactUs>
  ) {
    return createContactUs(...args)
  }
  public [LibraryElementEnum.LibraryOptInRecaptcha](
    ...args: Parameters<typeof createRecaptcha>
  ) {
    return createRecaptcha(...args)
  }
  public [LibraryElementEnum.LibraryBlogPostImage](
    ...args: Parameters<typeof createBlogPostImage>
  ) {
    return createBlogPostImage(...args)
  }
  public [LibraryElementEnum.LibraryCustomLogin](
    ...args: Parameters<typeof createNewCustomLogin>
  ) {
    return createNewCustomLogin(...args)
  }
  public [LibraryElementEnum.LibraryWebinarSessionLink](
    ...args: Parameters<typeof createWebinarSessionLink>
  ) {
    return createWebinarSessionLink(...args)
  }
  public [LibraryElementEnum.LibraryWebinarSessionDateTime](
    ...args: Parameters<typeof createWebinarSessionDateTime>
  ) {
    return createWebinarSessionDateTime(...args)
  }
  public [LibraryElementEnum.LibraryWebinarSessionVideo](
    ...args: Parameters<typeof createWebinarSessionVideo>
  ) {
    return createWebinarSessionVideo(...args)
  }
  public [LibraryElementEnum.LibraryWebinarCallToAction](
    ...args: Parameters<typeof createWebinarCallToAction>
  ) {
    return createWebinarCallToAction(...args)
  }
  public [LibraryElementEnum.LibraryWebinarRegistrationDate](
    ...args: Parameters<typeof createWebinarRegistrationDate>
  ) {
    return createWebinarRegistrationDate(...args)
  }

  public create = (libraryElementType: LibraryElementEnum) => {
    const creator = (this as TemporaryAny)[libraryElementType]

    if (typeof creator !== 'function') {
      // No default entity creator defined for libraryElementType
      return null
    }

    return creator.call(this)
  }
}
